import type { ManagedModalComponentProps } from "@shapr3d/frontend-lib";
import { Button, Modal } from "@shapr3d/frontend-lib";

import style from "./ARNotSupportedModal.module.css";

type ARNotSupportedModalProps = {
  modalProps: ManagedModalComponentProps;
};

export const ARNotSupportedModal = ({ modalProps }: ARNotSupportedModalProps) => {
  return (
    <Modal {...modalProps} size="small" persistent>
      <div className={style.container}>
        <div className={style.title}>Augmented Reality Preview Unavailable</div>
        <div className={style.text}>
          {`This AR preview can\u2019t be displayed.`}
          <br />
          {`Try a different browser, or check if your device and available memory support Augmented Reality.`}
        </div>
        <Button variant="primary" onClick={modalProps.onClose} className={style.button}>
          OK
        </Button>
      </div>
    </Modal>
  );
};
